import MarkerIcon from "@/assets/images/icons/marker_input.svg?inline";

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "gallery",

  data() {
    return {
      swiper: null,
      swiperOption: {
        height: 520,
        width: 900,
        speed: 600,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction"
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false
        },
        breakpoints: {
          991: {
            height: 325,
            width: 748
          },
          767: {
            height: 300,
            width: 355
          },
          374: {
            width: 300
          }
        }
      }
    };
  },

  props: ["images", "title"],

  beforeDestroy() {
    this.swiper.destroy;
    this.swiper.destroy(false, false);
  },

  mounted() {
    this.swiper = this.$refs.gallerySwiper.swiper;
  },

  // computed: {},

  // methods: {},

  components: {
    MarkerIcon,
    swiper,
    swiperSlide
  }
};
